import ctt from '@/utils/const/deviceType';

export const size = 'medium,small,mini';

export const valType = 'int,float,double,string,boolean,any';

export const elType = 'input,checkbox,radio,select,multiple,switch';

const common = ['disabled'];
export const elOptionMap = {
  input: common.concat(['maxLength', 'max', 'min']),
  default: common
};

export const sceneMap = {
  1: 'low',
  2: 'mid',
  3: 'high'
};

export const preventionList = [
  ['不屏蔽', 0],
  ['屏蔽故障', 1],
  ['屏蔽报警', 2],
  ['屏蔽故障和报警', 3]
];

export function getSceneList(deviceType) {
  const map = {
    [ctt.FCBR_100M]: [
      ['工作场景', 1],
      ['公共场景', 3]
    ],
    default: [
      ['室内', 1],
      ['室外', 3]
    ]
  };
  return map[deviceType] || map.default;
}

export const fakerData = [
  {
    itemName: '烟雾浓度下降百分比',
    value: { low: 1, high: 2 },
    itemCode: 'aa',
    list: [['相对滑动', 1]],
    itemType: 'int',
    disabled: false,
    display: true,
    max: 0,
    min: 0,
    maxLength: 5,
    precision: 0
  },
  {
    itemName: '烟雾浓度下降百分比',
    value: { low: 1, high: 2 },
    itemCode: 'bb',
    displayType: 'select',
    list: [
      ['相对滑动', 1],
      ['相对滑动2', 2],
      ['相对滑动3', 3]
    ],
    itemType: 'string',
    display: true,
    disabled: false,
    maxLength: 5
  },
  {
    itemName: '烟雾浓度下降百分比',
    value: { low: 1, high: 0 },
    itemCode: 'cc',
    displayType: 'switch',
    itemType: 'boolean',
    display: true,
    disabled: false
  },
  {
    itemName: '烟雾浓度下降百分比',
    value: { low: 1, high: 2 },
    itemCode: 'dd',
    displayType: 'radio',
    list: [
      ['相对滑动', 1],
      ['相对滑动2', 2],
      ['相对滑动3', 3]
    ],
    itemType: 'int',
    display: true,
    disabled: false
  },
  {
    itemName: '烟雾浓度下降百分比',
    value: { low: '1', high: '1' },
    itemCode: 'ee',
    displayType: 'checkbox',
    list: [
      ['相对滑动', '1'],
      ['相对滑动2', '2'],
      ['相对滑动3', '3']
    ],
    itemType: 'string',
    display: true,
    disabled: false
  }
];
